module.exports = __webpack_public_path__ + "static/media/ordered-by-officeluv.42c5657f.svg";